import React from "react";
import "./PaginaInicio.css";
import "./HomeworkPage.css";
import "./CalendarPage.css";
import Cabecera from "../Others/Cabecera";
import BotonBarraInferior from "../Others/BotonBarraInferior";
import PiePagina from "../Others/PiePagina";
import BarraSuperior from "../Others/BarraSuperior";
import BarraInferior from "../Others/BarraInferior";
import ZoomCalendarPanel from "../Others/ZoomCalendarPanel";

const barra_inferior = (
  <BarraInferior
    contenido={
      <>
        <BotonBarraInferior imagenSrc={require("../Assets/calendario.png")} texto="Calendario" redireccion="calendar-page" />
        <BotonBarraInferior imagenSrc={require("../Assets/tutoriales.png")} texto="Tutoriales" redireccion="a-pagina-tutoriales" />
        <BotonBarraInferior imagenSrc={require("../Assets/entregables.png")} texto="Entregables" redireccion="pagina-entregables-pdf" />
      </>
    }
  />
);

const menu_materias = <></>;
const menu_mensajes = <></>;
const menu_alertas = <></>;
const menu_actualizaciones = <></>;

const barra_superior = (
  <BarraSuperior
    menu_materias={menu_materias}
    menu_mensajes={menu_mensajes}
    menu_alertas={menu_alertas}
    menu_actualizaciones={menu_actualizaciones}
    redireccion="admin-home"
    profile_redireccion="a-profile-page"
  />
);

function CalendarPage() {
  return (
    <div className="contenedor-pagina">
      <Cabecera contenidosuperior={barra_superior} contenidoInferior={barra_inferior} />
      <div className="homework-container">
        <div className="h-title">
          <h1>Calendario</h1>
        </div>
        <div className="cal-holder">
          <ZoomCalendarPanel />
        </div>
      </div>
      <PiePagina imagenSrc={require("../Assets/lawbackground23.jpg")} />
      <footer>Grupo Derecho & Progreso &copy; 2024</footer>
    </div>
  );
}

export default CalendarPage;
